import { unitDivisor, unitSymbol, type Network } from "../../lib/units";

export interface GraphFilters {
  minValueSats: number;
  fromDate: string; // yyyy-mm-dd, empty = no bound
  toDate: string;
}

export const DEFAULT_FILTERS: GraphFilters = { minValueSats: 0, fromDate: "", toDate: "" };

export default function FilterPanel({
  filters,
  onChange,
  maxValueSats,
  network,
}: {
  filters: GraphFilters;
  onChange: (f: GraphFilters) => void;
  maxValueSats: number;
  network: Network;
}) {
  return (
    <div className="flex flex-wrap gap-4 items-end border border-ink-700 rounded-md p-3 text-xs bg-ink-950/40">
      <div>
        <label className="block text-muted mb-1">
          Hide transfers under {(filters.minValueSats / unitDivisor(network)).toFixed(6)} {unitSymbol(network)}
        </label>
        <input
          type="range"
          min={0}
          max={maxValueSats}
          value={filters.minValueSats}
          onChange={(e) => onChange({ ...filters, minValueSats: Number(e.target.value) })}
          className="w-40"
        />
      </div>
      <div>
        <label className="block text-muted mb-1">From</label>
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) => onChange({ ...filters, fromDate: e.target.value })}
          className="bg-ink-900 border border-ink-700 rounded-md px-2 py-1"
        />
      </div>
      <div>
        <label className="block text-muted mb-1">To</label>
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) => onChange({ ...filters, toDate: e.target.value })}
          className="bg-ink-900 border border-ink-700 rounded-md px-2 py-1"
        />
      </div>
      {(filters.minValueSats > 0 || filters.fromDate || filters.toDate) && (
        <button onClick={() => onChange(DEFAULT_FILTERS)} className="text-ledger-400 underline">
          Reset filters
        </button>
      )}
    </div>
  );
}
